// Base hive breakpoints
export default {
  small: {
    name: 'SMALL',
    width: 320,
    columnCount: 6,
    gutterWidth: 12,
    rowHeight: 8,
    marginOuter: 16
  },
  medium: {
    name: 'MEDIUM',
    width: 768,
    columnCount: 12,
    gutterWidth: 16,
    rowHeight: 8,
    marginOuter: 32
  },
  large: {
    name: 'LARGE',
    width: 1024,
    columnCount: 12,
    gutterWidth: 24,
    rowHeight: 8,
    marginOuter: 32
  },
  xlarge: {
    name: 'XLARGE',
    width: 1440,
    columnCount: 12,
    gutterWidth: 24,
    rowHeight: 8,
    marginOuter: 32
  },
  xxlarge: {
    name: 'XXLARGE',
    width: 1920,
    columnCount: 12,
    gutterWidth: 24,
    rowHeight: 8,
    marginOuter: 32
  },
  ultra: {
    name: 'ULTRA',
    width: 2560,
    columnCount: 12,
    gutterWidth: 24,
    rowHeight: 8,
    marginOuter: 32
  }
}
